import ADPParamService from "../../../services/admin/ADPParamService";
import ADPRefcodeService from "../../../services/admin/ADPRefcodeService";
import ASTInstrumentService from "../../../services/ast/ASTInstrumentService";
import ASTQrdetService from "../../../services/ast/ASTQrdetService";
import ASTQrService from "../../../services/ast/ASTQrService";

class qrService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async setSearchParam(recordFilter: any, pathName: any): Promise<any> {
        let param = { recordFilter };
        localStorage.setItem(pathName, JSON.stringify(param));
    }

    async getSearchParam(pathName: any): Promise<any> {
        const searchParam = localStorage.getItem(pathName);
        return searchParam ? JSON.parse(searchParam) : null
    }

    async findAll(recordFilter: any): Promise<any> {
        return await ASTQrService.findAll(recordFilter);
    }

    async getGenderDropdown(moduleId: string, referenceGroup: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }

    async getDropdown(moduleId: string, referenceGroup: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }

    async create(item: any): Promise<any> {
        return await ASTQrService.create(item);
    }

    async findAllQRdet(qrBatchId: any): Promise<any> {
        return await ASTQrdetService.getItemsByQrBatchId(qrBatchId);
    }

    async findOneInstrumentByQrId(qrId: any): Promise<any> {
        return await ASTInstrumentService.findOneByQrId(qrId);
    }

    async findOneInstrument(instrumentId: any): Promise<any> {
        return await ASTInstrumentService.getItemById(instrumentId);
    }
    
    
    async getPrinterName(parameterId: string): Promise<any> {
        return await ADPParamService.getItemById(parameterId);
    }

}

export default new qrService();
